(function () {
  "use strict";


  BulkArchiveUsersCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('BulkArchiveUsersCtrl', BulkArchiveUsersCtrl);

  function BulkArchiveUsersCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: ''
    };

    $scope.archiveTrainees = function() {
      $scope.modal.status = 'saving';
      $scope.$emit('bulkArchiveConfirmEvent', $scope.modal.data, function() {
        $scope.dismiss();
        $timeout(function() {
          $scope.modal.status = '';
        }, 500);
      });
    };

    $scope.$on('bulkArchiveEvent', function(event, data) {
      $scope.modal.status = '';
      $scope.modal.data = data;
    });
  }

})();
